// ═══════════════════════════════════════════════════════════
// Service Worker registration with auto-update prompt
// ═══════════════════════════════════════════════════════════

export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Register only in production (avoid Vite HMR conflicts in dev)
  if (import.meta.env?.DEV) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Check for updates periodically (every 60 min while open)
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);

        // When a new worker is waiting, auto-activate so user gets
        // the new version on next navigation
        const onUpdate = () => {
          if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
        };
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) onUpdate();
          });
        });
        // If a controller change happens, reload once to pick up new assets
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      })
      .catch(() => { /* registration failed — app still works online */ });
  });
}
